import { __decorate } from "tslib";
import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let LoadingSpinner = class LoadingSpinner extends LitElement {
    static get styles() {
        return css `
			.loadingSpinner {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: transparent;
			}
			.loadingSpinner__container {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-weight: 400;
			}
			.loadingSpinner__spinner {
				margin: 1em;
				display: inline-block;
				width: 2em;
				height: 2em;
				border-radius: 50%;
				border: 4px solid #e6e6e6;
				border-bottom-color: #00507c;
				animation: loadingSpinnerAnimation 0.7s linear infinite;
			}
			@keyframes loadingSpinnerAnimation {
				from {
					transform: rotate(0);
				}
				to {
					transform: rotate(360deg);
				}
			}		
		`;
    }
    render() {
        return html `
			<div class="loadingSpinner">
				<div class="loadingSpinner__container">
					<div class="loadingSpinner__spinner"></div>
					${this.loadingText || 'Loading'}
				</div>
			</div>
		`;
    }
};
__decorate([
    property()
], LoadingSpinner.prototype, "loadingText", void 0);
LoadingSpinner = __decorate([
    customElement('loading-spinner')
], LoadingSpinner);
export { LoadingSpinner };
//# sourceMappingURL=loadingSpinner.js.map